import { render, staticRenderFns } from "./RelationsChart.component.vue?vue&type=template&id=80dff400&"
import script from "./RelationsChart.component.vue?vue&type=script&lang=js&"
export * from "./RelationsChart.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports